export const JOB_STATUS_LABELS = {
  requested: 'Requested',
  confirmed: 'Confirmed',
  finding_vendor: 'Finding vendor',
  assigned: 'Assigned',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  closed: 'Closed',
};

export const JOB_STATUSES = Object.keys(JOB_STATUS_LABELS);

export const ACCOUNT_TYPE_LABELS = {
  residential: 'Residential',
  business: 'Business',
};

export const accountTypeOptions = Object.entries(ACCOUNT_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const jobStatusOptions = JOB_STATUSES.map((value) => ({
  value,
  label: JOB_STATUS_LABELS[value],
}));

export const PHOTO_PHASE_LABELS = {
  before: 'Before',
  after: 'After',
};
